import React, { useEffect, useState } from 'react';
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator';
import Panel from 'Components/Panel/Panel';
import ExecuteAxios from 'Components/ExecuteAxios/ExecuteAxios';
import PanelListDefault from 'Components/PanelListDefault/PanelListDefault';
import AutomaticallyListedAttributes from 'Components/AutomaticallyListedAttributes/AutomaticallyListedAttributes';
import ApplyAttributes from 'Components/ApplyAttributes/ApplyAttributes';
import NewEmployesDays from './NewEmployesDays/NewEmployesDays';
import Button from 'Components/Button/Button';
import LocalTimeFromInstant from 'Components/LocalTimeFromInstant/LocalTimeFromInstant';
import ResetVariables from 'Components/ResetVariables/ResetVariables';
import RemoveIdsNotFound from 'Components/RemoveIdsNotFound/RemoveIdsNotFound';

const ProductionEmployees = ({
    productionIdSelecteds,
    productionDaysIdSelecteds,
    onUpdateProductionDays,
    decreaseProductionPanelDay,
    reloadProductionDays
}) => {
    const [employeeDayId, setEmployeeDayId] = useState(null)
    const [dsEmployee, setDsEmployee] = useState(null)
    const [startTime, setStartTime] = useState(null)
    const [endTime, setEndTime] = useState(null)
    const [allocatedMinutes, setAllocatedMinutes] = useState(null)
    const [username, setUsername] = useState(null);
    const [dtUpdate, setDtUpdate] = useState(null);

    const [loadingProductionEmployees, setLoadingProductionEmployees] = useState(null)
    const [productionEmployeesIdsSelecteds, setProductionEmployeesIdsSelecteds] = useState([])
    const [showNewEmployesDaysPanel, setShowNewEmployesDaysPanel] = useState(false)

    const [productionEmployeesList, setProductDaysList] = useState(null)
    const [productDayDetail, setProductDayDetail] = useState(null)
    const [updating, setUpdating] = useState(false)
    const [balacingAlredyGenerated, setBalacingAlredyGenerated] = useState(false)

    const [resetEmployeesDay, setResetEmployeesDay] = useState(false)

    const attributeList = [
        { name: "id", value: employeeDayId, setter: setEmployeeDayId, allowsMultipleRecordsSelected: true },
        { name: "dsEmployee", value: dsEmployee, setter: setDsEmployee, cursor: 'pointer' },
        { name: "startTime", value: startTime, setter: setStartTime, onBlur: onBlurGenerateAvailableHours, readOnly: balacingAlredyGenerated },
        { name: "endTime", value: endTime, setter: setEndTime, onBlur: onBlurGenerateAvailableHours, readOnly: balacingAlredyGenerated },
        { name: "allocatedMinutes", value: allocatedMinutes, setter: setAllocatedMinutes },
        { name: "usernameUpdate", value: username, setter: setUsername, cursor: 'pointer' },
        { name: "dtUpdate", value: dtUpdate, setter: setDtUpdate, cursor: 'pointer' }
    ];

    async function onBlurGenerateAvailableHours() {
        await validateMinutesAvailableHours();
    }

    async function validateMinutesAvailableHours() {
        if (productionDaysIdSelecteds && productionDaysIdSelecteds.length === 1 && startTime && endTime) {
            const parameters = {
                id: employeeDayId,
                productionDayId: productionDaysIdSelecteds[0],
                startTime: LocalTimeFromInstant.getLocalTimeFromInstant(startTime),
                endTime: LocalTimeFromInstant.getLocalTimeFromInstant(endTime)
            };
            const allocatedMinutes = await ExecuteAxios.api('get', `/employee-day/get-amount-available-minutes-by-employee/`, { params: parameters });
            setAllocatedMinutes(allocatedMinutes);
        }
    }


    async function balacingGenerated() {
        if (productionDaysIdSelecteds && productionDaysIdSelecteds.length === 1) {
            const parameters = {
                id: employeeDayId,
                productionDayId: productionDaysIdSelecteds[0]
            };

            setBalacingAlredyGenerated(await ExecuteAxios.api('get', `/employee-day/check-if-generated-balancing-by-production-day/`, { params: parameters }))
        }
        return false
    }

    useEffect(() => {
        balacingGenerated()
    }, [productionIdSelecteds, productionDaysIdSelecteds])

    const productionPanelStyle = {
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100%',
        maxHeight: '100%',
        width: '100%'
    };

    const oneDaySelected = productionDaysIdSelecteds && productionDaysIdSelecteds.length === 1;

    function callToGetProductionRecord() {
        if (oneDaySelected) {
            getProductionRecords(productionDaysIdSelecteds[0])
        } else {
            setProductDaysList(null)
            setProductionEmployeesIdsSelecteds([])
        }
    }

    // Fica na mesma tela dos dias: troca de dia busca os colaboradores do novo dia
    useEffect(() => {
        callToGetProductionRecord()
    }, [productionIdSelecteds, productionDaysIdSelecteds])

    useEffect(() => {
        callToGetProductionRecord()
        if (productionEmployeesIdsSelecteds && productionEmployeesIdsSelecteds.length === 1) {
            getEmployeesSelectedDetail(productionEmployeesIdsSelecteds[0])
        }
    }, [decreaseProductionPanelDay])

    useEffect(() => {
        callToGetProductionRecord()
    }, [reloadProductionDays])

    useEffect(() => {
        if (!resetEmployeesDay) {
            return
        }
        setResetEmployeesDay(false)
        // Recarrega os dias (alocados mudam) e, pelo reloadProductionDays, os colaboradores
        onUpdateProductionDays(true)
    }, [resetEmployeesDay])


    useEffect(() => {
        if (productionEmployeesIdsSelecteds && productionEmployeesIdsSelecteds.length === 1) {
            getEmployeesSelectedDetail(productionEmployeesIdsSelecteds[0])
        }
    }, [productionEmployeesIdsSelecteds])

    async function getEmployeesSelectedDetail(productionEmployeesIdsSelected) {
        const parameters = { id: productionEmployeesIdsSelected }
        const productionEmployeeDetail = await ExecuteAxios.api('get', `/employee-day/get-employee-day-detail/`, { params: parameters });
        setProductDayDetail(productionEmployeeDetail);
        if (productionEmployeeDetail) {
            ApplyAttributes.applyAttributes(productionEmployeeDetail, attributeList)
        }

        if (!productionEmployeesIdsSelected || productionEmployeesIdsSelected.length === 0) {
            ResetVariables.resetVariables(attributeList);
        }
    }

    async function getProductionRecords(productionDaysIdSelected) {
        const parameters = { productionDayId: productionDaysIdSelected }
        const productionEmployeesList = await ExecuteAxios.api('get', `/employee-day/get-employee-day-grid/`, { params: parameters });
        setProductDaysList(productionEmployeesList);
        RemoveIdsNotFound.remove(productionEmployeesList, setProductionEmployeesIdsSelecteds, productionEmployeesIdsSelecteds)
    }

    async function deleteEmployeesIdsSelecteds(recordsSelected) {
        try {
            setLoadingProductionEmployees(true)
            const response = await ExecuteAxios.api('delete', `/employee-day/`, {
                params: {
                    productionEmployeesIds: recordsSelected.join(",")
                }
            });

            if (response) {
                setProductionEmployeesIdsSelecteds([]);
                setResetEmployeesDay(true)
            }
            return response
        } finally {
            setLoadingProductionEmployees(false)
        }
    }

    async function putEmployeesProduction() {
        try {
            setLoadingProductionEmployees(true)
            const response = await ExecuteAxios.api('put', `/employee-day/`, {
                id: productionEmployeesIdsSelecteds[0],
                startTime: LocalTimeFromInstant.getLocalTimeFromInstant(startTime),
                endTime: LocalTimeFromInstant.getLocalTimeFromInstant(endTime),
                allocatedMinutes: allocatedMinutes
            });

            if (response) {
                setResetEmployeesDay(true)
            }

            return response;
        } finally {
            setLoadingProductionEmployees(false)
        }
    }

    const getProductPanelListOrDetail = () => {
        if (!updating) {
            return (
                <PanelListDefault
                    onUpdateIdSelected={setProductionEmployeesIdsSelecteds}
                    idsSelected={productionEmployeesIdsSelecteds}
                    data={productionEmployeesList}
                    attributeList={attributeList}
                    isEmptyPanel={!oneDaySelected}
                    emptyMessage={oneDaySelected ? undefined : 'Selecione um dia para ver os colaboradores.'}
                />
            )
        } else {
            return (
                <AutomaticallyListedAttributes
                    list={productDayDetail}
                    attributeList={attributeList}
                />
            )
        }
    }

    const styleFilterButton = {
        width: '85px',
        float: 'right',
        color: (!getIfButtonShowNewEmployeesActive()) ? 'grey' : 'green',
        fontWeight: '600',
        textAlign: 'center',
        fontSize: '0.8em',
        cursor: 'pointer'
    };

    function getButtonShowNewEmployees() {
        if (updating) {
            return null;
        }

        return (
            <Button
                clickMethod={() => { setShowNewEmployesDaysPanel(true) }}
                buttonName={'Adicionar'}
                style={styleFilterButton}
                disabled={!getIfButtonShowNewEmployeesActive()}
            />
        )
    }

    function getIfButtonShowNewEmployeesActive() {
        if (!productionIdSelecteds || productionIdSelecteds.length !== 1 || !oneDaySelected) {
            return false
        }

        if (showNewEmployesDaysPanel) {
            return false
        }

        return true;
    }

    return (
        <>
            <NewEmployesDays
                onUpdateShowNewEmployesDaysPanel={setShowNewEmployesDaysPanel}
                onUpdateResetEmployeesDay={setResetEmployeesDay}
                showNewEmployesDaysPanel={showNewEmployesDaysPanel}
                productionDaysIdSelecteds={productionDaysIdSelecteds}
            />

            < LoadingIndicator loaded={(!oneDaySelected || productionEmployeesList) && !loadingProductionEmployees} >
                <Panel
                    titlePage={'Colaboradores do dia'}
                    style={productionPanelStyle}
                    enableDelete={true}
                    deleteFunction={deleteEmployeesIdsSelecteds}
                    canViewCRUD={true}
                    canDelete={productionEmployeesIdsSelecteds && productionEmployeesIdsSelecteds.length > 0}
                    readOnly={false}
                    recordsSelected={productionEmployeesIdsSelecteds}
                    updateNameButton={'Visualizar'}
                    canSaveAfterEdit={false}
                    putFunction={putEmployeesProduction}
                    viewOnlyOneRecordCRUD={false}
                    resetVariables={() => { ResetVariables.resetVariables(attributeList) }}
                    canEdit={productionEmployeesIdsSelecteds && productionEmployeesIdsSelecteds.length === 1}
                    enableEdit={true}
                    updating={updating}
                    setUpdating={setUpdating}
                    dataListedAttributes={productDayDetail}
                    attributeList={attributeList}
                    componentLeftButtons={getButtonShowNewEmployees()}
                >
                    {getProductPanelListOrDetail()}
                </Panel>
            </LoadingIndicator >
        </>
    )

};
export default ProductionEmployees;


